import {Component, h} from "preact";
import styles from './style.module.scss';

interface Props {
  readonly?: boolean;
  placeholder?: string;
  required?: boolean;
  type: string;
  onInputCallback: (value: any) => void;
  onEnterCallback?: (value?: any) => void;
  name?: string;
  autocomplete?: string;
}

interface State {
  inputValue: string;
}

export default class Input extends Component<Props, State> {

  constructor() {
    super();
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleEnterPressed = this.handleEnterPressed.bind(this);
  }

  state: State = {
    inputValue: ''
  };

  render() {
      return (
        <input class={this.getClassesFromProps()}
               type={this.getTypeFromProps()}
               value={this.state.inputValue}
               name={this.props.name}
               placeholder={this.props.placeholder}
               readOnly={this.props.readonly}
               onInput={this.handleInputChange}
               onKeyUp={this.handleEnterPressed}
               autocomplete={this.props.autocomplete}/>
      )
    }

  getClassesFromProps(): string {
    let classNames = [];
    classNames.push(styles['input']);
    return classNames.join(' ');
  }

  getTypeFromProps(): string {
    switch (this.props.type) {
      case 'text':
        return 'text';
      case 'email':
        return 'email';
      case 'password':
        return 'password';
      default:
        return 'text'
    }
  }

  handleInputChange(e: Event): void {
    const target = e.target as HTMLInputElement;
    const value = target.value;

    this.setState({inputValue: value});

    if (this.props && this.props.onInputCallback) {
      this.props.onInputCallback(value);
    }
  }

  handleEnterPressed(e: KeyboardEvent): void {
    if (e.key === 'Enter') {
      if (this.props && this.props.onEnterCallback) {
        this.props.onEnterCallback();
      }
    }
  }

}